module.exports = __webpack_public_path__ + "img/goods2.dc38b245.jpg";